import { type FC } from 'react';
import styled from 'styled-components';

import { Skeleton } from '@soluto-private/mx-asurion-ui-react';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export type SectionContainerProps = {
  children?: React.ReactNode;
  className?: string;
  dataTestId?: string;
  isLoading?: boolean;
  skeletonHeight?: string;
};

export const SectionContainer: FC<SectionContainerProps> = ({
  children,
  className,
  dataTestId,
  isLoading,
  skeletonHeight = '150px',
}) =>
  isLoading ? (
    <Skeleton height={skeletonHeight} />
  ) : (
    <Container className={className} data-testid={dataTestId}>
      {children}
    </Container>
  );
